import gql from 'graphql-tag'

export const GET_PERSONAL_DATA_FORM_TYPES = gql`
  query GetPersonalDataFormTypes {
    personalDataFormTypes {
      id
      name
      code
      useText
    }
  }
`

export const SUBMIT_PERSONAL_DATA_REQUEST = gql`
  mutation SubmitPersonalDataRequest($input: PersonalDataRequestInput!) {
    submitPersonalDataRequest(input: $input) {
      success
      email
      error
    }
  }
`

export const VERIFY_PERSONAL_DATA_REQUEST = gql`
  mutation VerifyPersonalDataRequest($hash: String!) {
    verifyPersonalDataRequest(hash: $hash) {
      status
      email
    }
  }
`
